import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { startLogout } from '../../actions/auth'
import { notesLogout, startAddNewNote } from '../../actions/notes'
import JournalEntries from './JournalEntries'

const Sidebar = () => {

    const { name } = useSelector(state => state.auth)
    const dispatch = useDispatch()

    const handleLogout = () => {
        dispatch(startLogout())
        dispatch(notesLogout())
    }

    const handleAddNew = () => {
        dispatch(startAddNewNote())
    }

    return (
        <aside className='journal__sidebar'>
            <div className="journal__sidebar-navbar mt-3">
                <h3>
                    <i className='far fa-moon'></i>
                    <span className='journal__sidebar-username'>{ name }</span>
                </h3>

                <button className='btn' onClick={ handleLogout }>
                    Logout
                </button>
            </div>

            <div 
                className="journal__new-entry"
                onClick={ handleAddNew }
            >
                <i className="far fa-calendar-plus fa-3x"></i>
                <p className='mt-3'>New Entry</p>
            </div>

            <JournalEntries />
        </aside>
    )
}

export default Sidebar